<template>
  <el-menu :default-active="$route.path" :default-openeds="level1" theme="dark" router style="background-color: #fff8e1">
    <template v-for="route in $router.options.routes" v-if="!route.meta.hidden && route.meta.content==dqmk1 ">
      <!-- 如果没有子路由或者只有一个子路由的, 就不生成子菜单 -->
      <el-menu-item v-if="!route.children || route.children.length == 1" :index="route.path" :key="route.path">
        <i class="el-icon-menu"></i>{{ route.meta.name }}
      </el-menu-item>
      <el-submenu v-else :index="route.path">
        <template slot="title"><i class="el-icon-menu"></i>{{ route.meta.name }}</template>
        <el-menu-item v-for="child in route.children" v-if="!child.meta.hidden" :index="route.path + '/' + child.path"
                      :key="route.path + '/' + child.path">{{ child.meta.name }}
        </el-menu-item>
      </el-submenu>
    </template>
  </el-menu>
</template>
<script>
import MainContent from '../main-content/main-content.vue';

export default {
  props: ['dqmk1'],
  data() {
    return {
      rolelist: []
    };
  },
  computed: {
    level1() {
      // 默认打开所有一级菜单
      const qx = localStorage.getItem('qx');

      return this.$router.options.routes.map(function (route) {
        if (route.path == "/basic" && 1==1) {
          route.children[1].meta.hidden = true
          route.children[2].meta.hidden = true
          route.children[3].meta.hidden = true
          route.children[4].meta.hidden = true
          route.children[5].meta.hidden = true
          if(qx && qx.includes('ckxxgl')){
            route.children[3].meta.hidden = false
          }
          if(qx && qx.includes('ckgys')){
            route.children[5].meta.hidden = false
          }
          if(qx && qx.includes('ckkc')){
            route.children[2].meta.hidden = false
          }
          if(qx && qx.includes('bzgys')){
            route.children[5].meta.hidden = false
          }
          if(qx && qx.includes('bzdls')){
            route.children[4].meta.hidden = false
          }
          if(qx && qx.includes('cprk')){
            route.children[1].meta.hidden = false
          }
          if(qx && qx.includes('cpck')){
            route.children[1].meta.hidden = false
          }
          if(qx && qx.includes('bzsj')){
            route.children[2].meta.hidden = false
          }
          if(qx && qx.includes('bzcbj')){
            route.children[2].meta.hidden = false
          }
          if(qx && qx.includes('cpdc')){
            route.children[2].meta.hidden = false
          }
          if(qx && qx.includes('spxxgl')){
            route.children[2].meta.hidden = false
          }

        }

        console.log(route)
        //route.children.get(5).meta.hidden=true
        // this.$router.options.routes=route

        return route.path;
      });
    }
  }
};
</script>
<style scoped>

.el-submenu .el-menu-item {
  height: 50px;
  line-height: 50px;
  padding: 0 45px;
  min-width: 185px;
}

.el-menu-item.is-active{
  color:#e65100
}
.el-menu-item{
  color:#ff9741
}
.el-menu-item:focus, .el-menu-item:hover {
  outline: 0;
  background-color: #fff3e0;
}
</style>